import type * as GraphQLTypes from '../../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsedGiftCardQueryVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String'];
  productType: GraphQLTypes.Scalars['String'];
}>;


export type GetUsedGiftCardQueryResult = (
  { __typename?: 'Query' }
  & { getUsedGiftCard?: GraphQLTypes.Maybe<(
    { __typename?: 'GiftCard' }
    & Pick<GraphQLTypes.GiftCard, 'id' | 'code' | 'amount'>
  )> }
);


export const GetUsedGiftCardDocument = /*#__PURE__*/ gql`
    query getUsedGiftCard($id: String!, $productType: String!) {
  getUsedGiftCard(id: $id, productType: $productType) {
    id
    code
    amount
  }
}
    `;

/**
 * __useGetUsedGiftCardQuery__
 *
 * To run a query within a React component, call `useGetUsedGiftCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsedGiftCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsedGiftCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useGetUsedGiftCardQuery(baseOptions: Apollo.QueryHookOptions<GetUsedGiftCardQueryResult, GetUsedGiftCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsedGiftCardQueryResult, GetUsedGiftCardQueryVariables>(GetUsedGiftCardDocument, options);
      }
export function useGetUsedGiftCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsedGiftCardQueryResult, GetUsedGiftCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsedGiftCardQueryResult, GetUsedGiftCardQueryVariables>(GetUsedGiftCardDocument, options);
        }
export type GetUsedGiftCardQueryHookResult = ReturnType<typeof useGetUsedGiftCardQuery>;
export type GetUsedGiftCardLazyQueryHookResult = ReturnType<typeof useGetUsedGiftCardLazyQuery>;